'use client';

import React, { useState } from 'react';
import { motion } from 'framer-motion'; // For smooth animations
import { FiMessageSquare } from 'react-icons/fi';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className='fixed bottom-4 right-4 z-50 chatbot'>
      {/* Button */}
      {!isOpen && (
        <button
          onClick={toggleChat}
          className='w-14 h-14 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-full shadow-lg flex items-center justify-center hover:scale-110 focus:outline-none transition-all'
        >
          <FiMessageSquare size={24} />
        </button>
      )}

      {/* Chat Widget */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.4 }}
          className='w-[100%] max-w-md h-[90vh] md:h-[80vh]  2xl:h-[70vh]  shadow-lg rounded-lg overflow-hidden'
        >
          {/* Close Button */}
          <div className='flex justify-end p-2 bg-gradient-to-r from-blue-500 to-purple-600'>
            <button
              onClick={toggleChat}
              className='text-gray-50 hover:text-gray-700 focus:outline-none'
            >
              ✖
            </button>
          </div>

          {/* Iframe */}
          <iframe
            src='https://www.chatbase.co/chatbot-iframe/h1XenewrvJTXyoSvOXeVD'
            width='100%'
            height='100%'
            style={{ border: 'none', flex: 1, overflow: 'hidden' }}
            title='Chatbot '
          ></iframe>
        </motion.div>
      )}
    </div>
  );
};

export default Chatbot;
